// extracted by mini-css-extract-plugin
export default {"container":"KbaPopup_container__muiXI","paper":"KbaPopup_paper__OIh9r","loaderContainer":"KbaPopup_loaderContainer__X249J"};